import type { FC, PropsWithChildren } from 'react';
import { Modal, ModalForm, InputsSection, ModalButtons } from '../../components/Modal';
import ModalHeading from '../../components/Modal/ModalHeading';
import ToggleModalSkeleton from '../../Skeletons/ToggleModalSkeleton';
import { ViewRulesModalState } from './ViewRulesModal';

type ModalProps = PropsWithChildren<{
  loading: boolean;
  toggleModal: ViewRulesModalState;
  onCloseModal?: () => void;
  handleToggle?: (event: React.FormEvent<HTMLFormElement>) => void;
}>;

const ToggleModal: FC<ModalProps> = props => {
  return (
    <Modal show={props.toggleModal.status}>
      <ModalHeading heading={`${props.toggleModal.data?.advertise.activeStatus ? 'Deactivate' : 'Activate'} ${props.toggleModal.data?.advertise.title}`} />
      {props.loading ? (
        <ToggleModalSkeleton />
      ) : (
        props.toggleModal.data && (
          <ModalForm style={{ marginBottom: '2.5rem' }} onSubmit={props.handleToggle}>
            <InputsSection style={{ width: '34rem' }}>
              {props.toggleModal.data.advertise.activeStatus ? (
                <p className='primaryText'>
                  All the rules will be deactivated after deactivating this campaign.
                  <br />
                  <br /> <span className='dangerText'>Are you sure you want to proceed?</span>
                </p>
              ) : (
                <p className='primaryText'>
                  All the rules will be activated after activating this campaign.
                  <br />
                  <br /> <span className='dangerText'>Are you sure you want to proceed?</span>
                </p>
              )}
            </InputsSection>

            <ModalButtons
              submitButtonLabel={props.toggleModal.data?.advertise.activeStatus ? 'Deactivate Campaign' : 'Activate Campaign'}
              cancelButtonLabel='Cancel'
              onCancel={props.onCloseModal}
            />
          </ModalForm>
        )
      )}
    </Modal>
  );
};

export default ToggleModal;
